<template>
  <success-box v-if="!eventNewYear" :title="title"/>
  <success-box-lunar-new-year v-else :title="title"/>
</template>
<script>
import SuccessBox from '@/components/commons/SuccessBox.vue';
import SuccessBoxLunarNewYear from '@/components/commons/SuccessBoxLunarNewYear.vue';

export default {
  name: 'RegisterSuccessful',
  components: {
    SuccessBox,
    SuccessBoxLunarNewYear,
  },
  data() {
    return {
      title: this.$t('common.successfull', { name: this.$t('title.register') }),
      eventNewYear: new Date().getTime() < new Date('2024/2/15').getTime(),
    };
  },
};
</script>
